import React from 'react';
import Menu from '../Menu';

import './SideDrawerStyles.scss';

const SideDrawer = React.forwardRef(({links, pos, classes, click, closeSideDrawerRef = null}, ref) => {
    const open = classes === 'collapse show';
    return (
        <nav className={`side-drawer-container ${open ?  'open' : ''}`}>
            <div className="header-container">
                <button className="closer-side-drawer" onClick={click} ref={ref}>
                    <span>Menü schließen</span>
                    <i className="la la-angle-double-left" />
                </button>
            </div>
            <ul className="navbar-nav">
                <Menu links={links} pos={pos} />
            </ul>
        </nav>
    );
});

export default SideDrawer;
